/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdOrders200Ok
 */
export interface GetCorporationsCorporationIdOrders200Ok {
    /**
     * Number of days for which order is valid (starting from the issued date). An order expires at time issued + duration
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    duration: number;
    /**
     * For buy orders, the amount of ISK in escrow
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    escrow?: number;
    /**
     * True if the order is a bid (buy) order
     * @type {boolean}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    isBuyOrder?: boolean;
    /**
     * Date and time when this order was issued
     * @type {Date}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    issued: Date;
    /**
     * The character who issued this order
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    issuedBy: number;
    /**
     * ID of the location where order was placed
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    locationId: number;
    /**
     * For buy orders, the minimum quantity that will be accepted in a matching sell order
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    minVolume?: number;
    /**
     * Unique order ID
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    orderId: number;
    /**
     * Cost per unit for this order
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    price: number;
    /**
     * Valid order range, numbers are ranges in jumps
     * @type {string}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    range: GetCorporationsCorporationIdOrders200OkRangeEnum;
    /**
     * ID of the region where order was placed
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    regionId: number;
    /**
     * The type ID of the item transacted in this order
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    typeId: number;
    /**
     * Quantity of items still required or offered
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    volumeRemain: number;
    /**
     * Quantity of items required or offered at time order was placed
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    volumeTotal: number;
    /**
     * The corporation wallet division used for this order.
     * @type {number}
     * @memberof GetCorporationsCorporationIdOrders200Ok
     */
    walletDivision: number;
}


/**
 * @export
 */
export const GetCorporationsCorporationIdOrders200OkRangeEnum = {
    _1: '1',
    _10: '10',
    _2: '2',
    _20: '20',
    _3: '3',
    _30: '30',
    _4: '4',
    _40: '40',
    _5: '5',
    Region: 'region',
    Solarsystem: 'solarsystem',
    Station: 'station'
} as const;
export type GetCorporationsCorporationIdOrders200OkRangeEnum = typeof GetCorporationsCorporationIdOrders200OkRangeEnum[keyof typeof GetCorporationsCorporationIdOrders200OkRangeEnum];


/**
 * Check if a given object implements the GetCorporationsCorporationIdOrders200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdOrders200Ok(value: object): value is GetCorporationsCorporationIdOrders200Ok {
    if (!('duration' in value) || value['duration'] === undefined) return false;
    if (!('issued' in value) || value['issued'] === undefined) return false;
    if (!('issuedBy' in value) || value['issuedBy'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('orderId' in value) || value['orderId'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('range' in value) || value['range'] === undefined) return false;
    if (!('regionId' in value) || value['regionId'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    if (!('volumeRemain' in value) || value['volumeRemain'] === undefined) return false;
    if (!('volumeTotal' in value) || value['volumeTotal'] === undefined) return false;
    if (!('walletDivision' in value) || value['walletDivision'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdOrders200OkFromJSON(json: any): GetCorporationsCorporationIdOrders200Ok {
    return GetCorporationsCorporationIdOrders200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdOrders200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdOrders200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'duration': json['duration'],
        'escrow': json['escrow'] == null ? undefined : json['escrow'],
        'isBuyOrder': json['is_buy_order'] == null ? undefined : json['is_buy_order'],
        'issued': (new Date(json['issued'])),
        'issuedBy': json['issued_by'],
        'locationId': json['location_id'],
        'minVolume': json['min_volume'] == null ? undefined : json['min_volume'],
        'orderId': json['order_id'],
        'price': json['price'],
        'range': json['range'],
        'regionId': json['region_id'],
        'typeId': json['type_id'],
        'volumeRemain': json['volume_remain'],
        'volumeTotal': json['volume_total'],
        'walletDivision': json['wallet_division'],
    };
}

export function GetCorporationsCorporationIdOrders200OkToJSON(json: any): GetCorporationsCorporationIdOrders200Ok {
    return GetCorporationsCorporationIdOrders200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdOrders200OkToJSONTyped(value?: GetCorporationsCorporationIdOrders200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'duration': value['duration'],
        'escrow': value['escrow'],
        'is_buy_order': value['isBuyOrder'],
        'issued': ((value['issued']).toISOString()),
        'issued_by': value['issuedBy'],
        'location_id': value['locationId'],
        'min_volume': value['minVolume'],
        'order_id': value['orderId'],
        'price': value['price'],
        'range': value['range'],
        'region_id': value['regionId'],
        'type_id': value['typeId'],
        'volume_remain': value['volumeRemain'],
        'volume_total': value['volumeTotal'],
        'wallet_division': value['walletDivision'],
    };
}

